if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
  evt.preventDefault();

  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  const productLimit = parseInt(this.dataset.productLimit || '0');
  const cartQuantity = parseInt(this.dataset.cartQuantity || '0');
  const quantityInput = this.form.querySelector('[name="quantity"]');
  const requestedQuantity = parseInt(quantityInput?.value || '1');

  if (productLimit > 0 && cartQuantity + requestedQuantity > productLimit) {
    const remainingQuantity = Math.max(productLimit - cartQuantity, 0);

    this.handleErrorMessage(
      remainingQuantity > 0
        ? `You can only add ${remainingQuantity} more of this product.`
        : 'Limit reached'
    );

    return;
  }

  if (this.submitButton.disabled) return;

  this.handleErrorMessage();

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');

  const spinner = this.querySelector('.loading__spinner');
  if (spinner) spinner.classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );

          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');

              this.error = true;
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;

            /*
             * The /cart/add response does not reliably contain the
             * complete cart contents, so get the cart once after
             * a successful add. This lets us calculate the total
             * quantity by PRODUCT, including multiple variants.
             */
            updateLimitedProductCardsFromCart();

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');

          if (text) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


/*
 * ---------------------------------------------------------
 * LIMITED PRODUCT CARD SYNC
 * ---------------------------------------------------------
 *
 * Product cards provide:
 *
 * data-product-id
 * data-product-limit
 * data-cart-quantity
 *
 * The limit is PRODUCT-level, so all variants are counted
 * together.
 */

function updateLimitedProductCards(cartItems) {
  const cards = document.querySelectorAll(
    'product-form[data-product-id][data-product-limit], ' +
    'modal-opener[data-product-id][data-product-limit]'
  );

  cards.forEach((productForm) => {
    const productId = Number(productForm.dataset.productId);
    const productLimit = Number(productForm.dataset.productLimit);

    if (!productId || !productLimit || productLimit <= 0) return;

    const cartQuantity = cartItems
      .filter((item) => Number(item.product_id) === productId)
      .reduce((total, item) => total + Number(item.quantity), 0);

    productForm.dataset.cartQuantity = cartQuantity;

    const button = productForm.querySelector('[type="submit"]');
    const buttonText = button?.querySelector('span');

    if (!button || !buttonText) return;

    // Preserve Shopify's original sold-out state.
    const soldOutMessage = button.querySelector('.sold-out-message');
    const isSoldOut =
      button.dataset.soldOut === 'true' ||
      buttonText.textContent.trim().toLowerCase() === 'sold out' ||
      (soldOutMessage && !soldOutMessage.classList.contains('hidden'));

    if (isSoldOut) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      return;
    }

    // Apply the customer purchase limit only to available products.
    if (cartQuantity >= productLimit) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.dataset.limitReached = 'true';
      buttonText.textContent = 'Limit reached';
    } else {
      // Don't override a disabled state owned by Shopify or another script.
      if (button.disabled && button.dataset.limitReached !== 'true') return;

      button.disabled = false;
      button.removeAttribute('aria-disabled');
      delete button.dataset.limitReached;

      buttonText.textContent =
        button.dataset.defaultText || window.variantStrings.addToCart;
    }
  });
}


/*
 * Fetch the current cart once.
 *
 * This is used after an AJAX Add to cart because the
 * /cart/add response doesn't give us the complete cart
 * needed to calculate product-level quantities.
 */
async function updateLimitedProductCardsFromCart() {
  try {
    const response = await fetch('/cart.js');

    if (!response.ok) return;

    const cart = await response.json();

    updateLimitedProductCards(cart.items || []);
  } catch (error) {
    console.error('Error updating limited product cards:', error);
  }
}


/*
 * Listen for existing Shopify/Dawn cart updates.
 *
 * CartItems already publishes cartData after quantity changes,
 * so we can update the product cards without another /cart.js
 * request.
 */
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (!event?.cartData?.items) return;

    updateLimitedProductCards(event.cartData.items);
  });
}


/*
 * Initialise the cards when the page loads.
 *
 * Liquid already supplies the initial cart quantity, so this
 * is mainly useful if the DOM is loaded/replaced dynamically.
 */
document.addEventListener('DOMContentLoaded', () => {
  updateLimitedProductCardsFromCart();
});